var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSubc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00168 12C5.63471 12 5.2639 11.8597 4.98339 11.5773L0.422207 7.01805C-0.140736 6.45511 -0.140736 5.54441 0.422207 4.98147C0.98515 4.41852 1.89585 4.41852 2.45879 4.98147L6.00168 8.52051L14.1019 0.422207C14.6649 -0.140736 15.5756 -0.140736 16.1385 0.422207C16.7014 0.98515 16.7014 1.89585 16.1385 2.45879L7.01998 11.5773C6.73946 11.8597 6.37057 12 6.00168 12",
    fill: "#B9B5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSubc);
export default __webpack_public_path__ + "static/media/check-subc.87078ea6c781425eb775338c069f7160.svg";
export { ForwardRef as ReactComponent };